import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import api from "../../api/client";

/**
 * تغيير كلمة المرور — يتطلب الكلمة الحالية.
 * بعد النجاح تُبطَل كل الجلسات (tokenVersion) ويُعاد المستخدم لتسجيل الدخول.
 */
export default function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent]   = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  if (!user) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (password.length < 10)          { setError("كلمة المرور يجب أن تكون 10 محارف على الأقل"); return; }
    if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) {
      setError("كلمة المرور يجب أن تحتوي حرفاً ورقماً على الأقل"); return;
    }
    if (password !== confirm)          { setError("تأكيد كلمة المرور غير متطابق"); return; }

    setLoading(true);
    try {
      await api.post("/auth/change-password", { currentPassword: current, newPassword: password });
      // الخادم أبطل الجلسة — ننظّف الحالة المحلية ونعود للدخول
      await logout().catch(() => {});
      navigate("/login", { replace: true, state: { message: "تم تغيير كلمة المرور. سجّل الدخول بالكلمة الجديدة" } });
    } catch (err: unknown) {
      setError(
        (err as { response?: { data?: { error?: { message?: string } } } })
          ?.response?.data?.error?.message ?? "حدث خطأ"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="page-header">
        <h1 className="page-title">حسابي</h1>
        <p className="page-subtitle">{user.fullName} — {user.username}</p>
      </div>

      {user.mustChangePwd && (
        <div className="alert-error mb-4">
          كلمة المرور الحالية مؤقتة — يجب تغييرها قبل متابعة استخدام النظام.
        </div>
      )}
      {error && <div className="alert-error mb-4">{error}</div>}

      <form onSubmit={handleSubmit} className="card space-y-4">
        <h2 className="font-semibold text-gray-800">تغيير كلمة المرور</h2>
        <div>
          <label className="label" htmlFor="current">كلمة المرور الحالية</label>
          <input id="current" type="password" className="input" autoComplete="current-password"
            value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </div>
        <div>
          <label className="label" htmlFor="password">كلمة المرور الجديدة</label>
          <input id="password" type="password" className="input" autoComplete="new-password"
            value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} />
          <p className="text-[11px] text-gray-400 mt-1">10 محارف على الأقل، تتضمن حرفاً ورقماً</p>
        </div>
        <div>
          <label className="label" htmlFor="confirm">تأكيد كلمة المرور</label>
          <input id="confirm" type="password" className="input" autoComplete="new-password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? "جاري الحفظ..." : "حفظ كلمة المرور"}
        </button>
      </form>
    </div>
  );
}
